
class IntegratorMappingEntityCell extends UITableViewCell
{
    private sourceEntityLabel: MUILabel = null;
    private sourceIDLabel: MUILabel = null;
    private targetLabel: MUILabel = null;

    awakeFromHTML() {
        this.sourceEntityLabel = MUIOutlet(this, "source-entity-lbl", "MUILabel");
        this.sourceIDLabel = MUIOutlet(this, "source-id-lbl", "MUILabel");
        this.targetLabel = MUIOutlet(this, "target-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(item: IntegratorMappingEntity) {
        this.sourceEntityLabel.text = item.sourceEntityName;
        this.sourceIDLabel.text = item.sourceID;

        let target = item.targetEntity;
        this.targetLabel.text = target != null ? target.targetEntityName + " · " + target.targetID : "";
    }
}
